import { useEffect, useState } from "react";
import { CourseFinanceCategoryApi, courseFinanceCategoriesApi } from "./courseFinanceCategoriesApi";

export const useCourseFinanceCategory = (id: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<CourseFinanceCategoryApi | null>(null);

  useEffect(() => {
    const fetchCategory = async () => {
      if (!id) {
        console.error("Finance category id not found.");
        setLoading(false);
        return;
      }
      const res = await courseFinanceCategoriesApi.fetchById(id);
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategory();
  }, [id]);

  return { loading, data };
};
